// extracted by mini-css-extract-plugin
module.exports = {"one-row":"SectionContent_layouts_one-row__2bgYF","one-column":"SectionContent_layouts_one-column__1WdLz","two-column":"SectionContent_layouts_two-column__3n1EU"};